<template>
    <div>
        <p style="display: flex;
            font-size: 30px;
            flex-direction: row;
            height: 45px;
            color: rgb(2215,114,2); 
            border-bottom: solid 0.06rem rgb(193,193,193);">
            Protein-Protein Interaction
        </p>
        <el-card style="width:100%;
               height:auto;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               font-size: 14px;">
               <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 16px;text-align: left;line-height: 23px;">
                In this visualization section, 
                we obtained the <strong style="font-size:20px;">physical protein-protein interaction(PPI)</strong> between the MDD-related genes in MDDOmics from the <a href="https://string-db.org/">STRING database</a>, 
                which is more reliable than the predicted interaction.
                <br/> You can input a gene name and view its PPI sub-network, 
                or view the PPI network between genes on different chromosomes. Click the legends left to select the chromosomes.<br/>
                <ul>
                    <li>The score of the edge comes from STRING database, reflecting the strength of the interaction,
                        which is also represented by the thickness of the edge. </li>
                    <li>The node information comes from MDDOmics.</li>
                </ul>
                
               </div>
        </el-card>
        <div id="ppiplot">
            <PPIchartVue :legendAll="legendAll" ref="ppichart" :nodes="nodes" :edges="edges" style="margin-top:30px"></PPIchartVue>
        </div>
       
        <el-card class="box-card" 
            style="height:auto;
            width:25%;
            background-color: rgba(255,208,75,0.05);
            color: rgb(250,170,0);
            font-size: 12px;
            position: absolute;
            bottom:700px;
            right:150px">
            <input type="text" id="inputSearch" placeholder="Enter single gene name here" v-model="searchValue" style="outline:none;height:35px;width:65%;">
            <el-button size="small" @click="search()" type="warning" style="font-size: 11px;text-align:center;margin-left:1%;width:27%;height:40px">Search</el-button>
            <br/><br/>
        </el-card>  
        
    </div>
    
</template>

<script>
import{Loading}from'element-ui';
import PPIchartVue from '../../chart/PPIchart.vue'
export default ({
    data(){
        return{
            nodes:null,
            edges:null,
            searchValue:null,
            legendAll:false,
        }
    },
    components:{
        PPIchartVue
    },
    mounted(){
        this.getData()
    },
    methods:{
        getData(){
            var loadingInstance = Loading.service({
                target:document.querySelector('#ppiplot')
            });
            this.axios.get(this.GLOBAL.rootAddress+'visualization/PPI',{
            params: { 
                 'gene_name': this.searchValue
                }
            })
            .then(response=> {    
                loadingInstance.close();  
                if(response.data.data.edges.length==0){
                    this.$message.error("The gene was not found in the network!"); 
                    return
                }
                this.edges=response.data.data.edges; 
                this.nodes=response.data.data.nodes;   
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
        },
        search(){
            this.getData()
            if(this.searchValue){
                this.legendAll=true
            }else this.legendAll=false
        }

    }
})
</script>
